var _path, _mask, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11V11.6213C22 11.8047 21.8513 11.9534 21.668 11.9534H0.332037C0.148658 11.9534 0 11.8047 0 11.6213V11Z",
    fill: "#E7AB00"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1663_3402",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 10.9027C1.65625 5.74208 5.83974 1.55859 11.0003 1.55859C16.1609 1.55859 20.3444 5.74208 20.3444 10.9027V11.6641C20.3444 11.8236 20.2152 11.9528 20.0557 11.9528H1.94498C1.78552 11.9528 1.65625 11.8236 1.65625 11.6641V10.9027Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 10.9027C1.65625 5.74208 5.83974 1.55859 11.0003 1.55859C16.1609 1.55859 20.3444 5.74208 20.3444 10.9027V11.6641C20.3444 11.8236 20.2152 11.9528 20.0557 11.9528H1.94498C1.78552 11.9528 1.65625 11.8236 1.65625 11.6641V10.9027Z",
    fill: "#FFC727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 1.55859H20.3444H1.65625ZM20.3444 11.6641C20.3444 12.3758 19.7674 12.9528 19.0557 12.9528H2.94498C2.23323 12.9528 1.65625 12.3758 1.65625 11.6641V10.9528C1.65625 10.9528 1.78552 10.9528 1.94498 10.9528H20.0557C20.2152 10.9528 20.3444 10.9528 20.3444 10.9528V11.6641ZM1.65625 11.9528V1.55859V11.9528ZM20.3444 1.55859V11.9528V1.55859Z",
    fill: "#E7AB00",
    mask: "url(#path-2-inside-1_1663_3402)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8403 12.6514C14.909 12.4881 15.1404 12.4881 15.209 12.6514L16.8542 16.564C16.9096 16.6959 16.8128 16.8416 16.6698 16.8416H13.3795C13.2365 16.8416 13.1397 16.6959 13.1951 16.564L14.8403 12.6514Z",
    fill: "#E7AB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 17.1272C16.8984 18.1615 16.06 19 15.0257 19C13.9914 19 13.1529 18.1615 13.1529 17.1272V16.7371H16.8984V17.1272Z",
    fill: "#E7AB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3027 10.4736C11.234 10.6369 11.0026 10.6369 10.934 10.4736L8.77662 5.34288C8.72119 5.21106 8.81799 5.06536 8.96098 5.06536H13.2757C13.4187 5.06536 13.5155 5.21106 13.46 5.34288L11.3027 10.4736Z",
    fill: "#E7AB00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75391 4.70153C8.75391 3.39505 9.81302 2.33594 11.1195 2.33594C12.426 2.33594 13.4851 3.39505 13.4851 4.70153V5.19435H8.75391V4.70153Z",
    fill: "#E7AB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5438 10.7359C10.6174 10.8945 10.4907 11.0712 10.3331 11.0299L5.31988 9.71513C5.18304 9.67925 5.12392 9.50068 5.2094 9.38144L7.88351 5.65113C7.96899 5.53189 8.14088 5.55314 8.20472 5.69084L10.5438 10.7359Z",
    fill: "#E7AB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03262 9.51444C3.98339 8.60684 3.78805 6.95705 4.59632 5.82953C5.4046 4.702 6.91041 4.52371 7.95965 5.43131L8.10423 5.55637L5.1772 9.6395L5.03262 9.51444Z",
    fill: "#E7AB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8304 11.0052C11.6726 11.0457 11.5469 10.8684 11.6212 10.7102L13.9842 5.67861C14.0488 5.5412 14.2208 5.52081 14.3057 5.6405L16.9621 9.3861C17.047 9.5058 16.9869 9.68408 16.8498 9.7192L11.8304 11.0052Z",
    fill: "#E7AB00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2351 5.41915C15.2897 4.51672 16.7954 4.70293 17.5983 5.83507C18.4013 6.96721 18.1973 8.61655 17.1428 9.51898L16.9994 9.64166L14.0918 5.54183L14.2351 5.41915Z",
    fill: "#E7AB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.4cae1e28604ae3678545c9687536592d.svg";
export { ForwardRef as ReactComponent };